<template>
  <div>
    <div @click.stop="openModal">
      <slot></slot>
    </div>

    <Modal :is-modal-active="isModalVisible || active" @close="closeModal">
      <template #title>
        <template v-if="activeForm === FORM_TYPES.LOGIN">
          <span> Log in </span><br />to an existing account
        </template>
        <template v-else-if="activeForm === FORM_TYPES.REGISTER">
          <span> Sign up </span> <br />
          for a new account
        </template>
        <template v-else-if="activeForm === FORM_TYPES.FORGOT">
          Forgot password
        </template>
      </template>

      <template v-if="activeForm === FORM_TYPES.LOGIN">
        <CustomInput
          v-model="payload.email"
          class-name="custom-input"
          type="email"
          :value="payload.email"
          placeholder="Username or email"
          input-type="email"
        >
        </CustomInput>
        <CustomInput
          v-model="payload.password"
          class-name="custom-input"
          type="password"
          :value="payload.password"
          placeholder="Password"
          input-type="password"
        >
        </CustomInput>
        <RippleButton type="prime" @click.stop="login" v-html="'Login'" />
        <RippleButton
          type="second"
          @click.stop="toggleForm(FORM_TYPES.REGISTER)"
          v-html="'Sign in'"
        />
        <span class="bottom-link" @click.stop="toggleForm(FORM_TYPES.FORGOT)"
          >Forgot password?</span
        >
        <div class="separator">
          <div class="block"></div>
          <span class="text">or</span>
          <div class="block"></div>
        </div>
        <div class="alternative">
          <RippleButton class-name="social-media" @click.stop="loginWithFacebook">
            <FacebookIcon />
          </RippleButton>
          <RippleButton class-name="social-media" @click.stop="loginWithGoogle">
            <GoogleIcon />
          </RippleButton>
          <RippleButton class-name="social-media" @click.stop="loginWithApple">
            <AppleIcon />
          </RippleButton>
        </div>
      </template>

      <template v-else-if="activeForm === FORM_TYPES.REGISTER">
        <CustomInput
          v-model="payload.username"
          class-name="custom-input"
          type="text"
          :value="payload.username"
          placeholder="Username"
          input-type="username"
        >
        </CustomInput>
        <CustomInput
          v-model="payload.email"
          class-name="custom-input"
          type="email"
          :value="payload.email"
          placeholder="email"
          input-type="email"
        >
        </CustomInput>
        <CustomInput
          v-model="payload.password"
          class-name="custom-input"
          type="password"
          :value="payload.password"
          placeholder="Password"
          input-type="password"
        >
        </CustomInput>
        <Checkbox v-model="agreeTerms">
          {{ $t("auth_confirm.pre") }}
          <a
            href="/privacy_policy"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            >{{ $t("auth_confirm.policy") }}</a
          >
          {{ $t("auth_confirm.and") }}
          <a
            href="/terms_and_conditions"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            >{{ $t("auth_confirm.terms") }}</a
          >.
        </Checkbox>
        <RippleButton
          type="prime"
          :disabled="!agreeTerms"
          @click.stop="signup"
          v-html="'Sign up'"
        />
        <RippleButton
          type="second"
          @click.stop="toggleForm(FORM_TYPES.LOGIN)"
          v-html="'Login'"
        />
        <div class="separator">
          <div class="block"></div>
          <span class="text">or</span>
          <div class="block"></div>
        </div>
        <div class="alternative">
          <RippleButton class-name="social-media" @click.stop="loginWithFacebook">
            <FacebookIcon />
          </RippleButton>
          <RippleButton class-name="social-media" @click.stop="loginWithGoogle">
            <GoogleIcon />
          </RippleButton>
          <RippleButton class-name="social-media" @click.stop="loginWithApple">
            <AppleIcon />
          </RippleButton>
        </div>
      </template>

      <template v-else-if="activeForm === FORM_TYPES.FORGOT">
        <CustomInput
          v-model="payload.email"
          class-name="custom-input"
          type="email"
          :value="payload.email"
          placeholder="email"
          input-type="email"
        >
        </CustomInput>
        <RippleButton
          type="prime"
          @click.stop="forgotPassword"
          v-html="'Reset password'"
        />
        <RippleButton
          type="second"
          @click.stop="toggleForm(FORM_TYPES.LOGIN)"
          v-html="'Login'"
        />
      </template>
    </Modal>
  </div>
</template>

<script>
import RippleButton from "../common/form/Button.vue";
import CustomInput from "../common/form/Input.vue";
import FacebookIcon from "../common/icons/Facebook.vue";
import GoogleIcon from "../common/icons/Google.vue";
import AppleIcon from "../common/icons/Apple.vue";
import Checkbox from "../common/form/Checkbox.vue";
import Modal from "./Modal.vue";
import { url } from "../../api.js";

const FORM_TYPES = {
  LOGIN: "login",
  REGISTER: "register",
  FORGOT: "forgot",
};

export default {
  name: "ModalAuth",
  components: {
    FacebookIcon,
    GoogleIcon,
    AppleIcon,
    RippleButton,
    CustomInput,
    Modal,
    Checkbox,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    FORM_TYPES,
    activeForm: FORM_TYPES.LOGIN,
    isModalVisible: false,
    payload: {
      username: "",
      email: "",
      password: "",
    },
    agreeTerms: false,
    loading: false,
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    openModal() {
      console.log("setSort");
      this.$emit("open");
      this.isModalVisible = true;
    },
    closeModal() {
      if (this.$route.name === "login") this.$router.push("/");
      this.isModalVisible = false;
    },

    toggleForm(form) {
      setTimeout(() => {
        this.activeForm = form;
      }, 0);
    },
    login() {
      if (this.loading) return;
      this.loading = true;

      const { email, password } = this.payload;

      this.$store
        .dispatch("login", { email, password })
        .then(() => {
          this.closeModal();
          this.$router.go();
          this.loading = false;
        })
        .catch((text) => {
          this.$notify({
            type: "error",
            title: `❌ ${this.$t("Error")}`,
            text,
          });
          this.loading = false;
        });
    },
    signup() {
      if (this.loading) return;
      this.loading = true;
      const { username, email, password } = this.payload;

      this.$store
        .dispatch("register", { username, email, password })
        .then((text) => {
          this.$notify({
            type: "success",
            title: `🎉 ${this.$t("Success")}`,
            text,
          });
          this.toggleForm(FORM_TYPES.LOGIN);
          this.loading = false;
        })
        .catch((text) => {
          this.$notify({
            type: "error",
            title: `❌ ${this.$t("Error")}`,
            text,
          });
          this.loading = false;
        });
    },
    forgotPassword() {
      if (this.loading) return;
      this.loading = true;

      const { email } = this.payload;

      this.$store
        .dispatch("forget", { email })
        .then((text) => {
          this.$notify({
            type: "success",
            title: `🎉 ${this.$t("Success")}`,
            text,
          });
          this.toggleForm(FORM_TYPES.LOGIN);
          this.loading = false;
        })
        .catch((text) => {
          this.$notify({
            type: "error",
            title: `❌ ${this.$t("Error")}`,
            text,
          });
          this.loading = false;
        });
    },
    loginWithGoogle() {
      const googleAuthUrl = `${url}v2/auth/google?uuid=${localStorage.getItem("uuid") || ""}`;
      window.location.href = googleAuthUrl;
    },
    loginWithFacebook() {
      const facebookAuthUrl = `${url}v2/auth/facebook?uuid=${localStorage.getItem("uuid") || ""}`;
      window.location.href = facebookAuthUrl;
    },
    loginWithApple() {
      const appleAuthUrl = `${url}v2/auth/apple?uuid=${localStorage.getItem("uuid") || ""}`;
      window.location.href = appleAuthUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.link{
  text-decoration: underline;
  color: var(--brand-color);
}
.bottom-link {
  color: #909da2;
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

.separator {
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;

  .text {
    font-size: 18px;
    line-height: 32px;
    color: var(--font-color);
  }

  .block {
    width: 100%;
    height: 1px;
    background-color: #e6e9ea;
    margin-bottom: 0;
  }
}

.alternative {
  display: flex;
  align-items: center;
  gap: 29px;
  width: 100%;
  margin-bottom: 70px;

  .social-media {
    background-color: #f3f5f6;
    border-radius: 6px;
    height: 60px;
    padding: 7px;

    svg {
      width: 100%;
      height: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  .alternative {
    margin-bottom: 0;
    // три кнопки замість двох — на вузьких екранах зменшуємо проміжок
    gap: 16px;
  }
}

@media screen and (max-width: 568px) {
  .alternative {
    margin-bottom: 0;
  }
}
</style>
